import { useMemo } from "react";
// Redux
import { useSelector } from "react-redux";
// React Query
import { useQuery } from "@tanstack/react-query";

// MUI
import { Box, Skeleton } from "@mui/material";

// Context
import { useInventoryContext } from "@/DataPages/components/Inventory/contexts/InventoryFilterContext";

// API
import { getGPSEmbeddedURL } from "@DataPages/api/inventory/queries";
// Types
import { RootState } from "@/redux/store";

type AssetLocationManagementProps = {};

export default function AssetLocationManagement(_props: Readonly<AssetLocationManagementProps>) {
	const location = useSelector((state: RootState) => state.location?.location);
	const locationId = location?.locationId;
	const accountId = location?.services?.find((service) => service.type === "GPS")?.accountId;

	const { filterItems } = useInventoryContext();

	const selectedVins = useMemo(() => filterItems.map(({ vinNumber }) => String(vinNumber)) ?? [], [filterItems]);

	/**************************************** QUERIES ****************************************/
	const { data: url, isLoading: isLoadingEmbeddedURL } = useQuery({
		queryKey: ["assetLocationManagement", locationId, accountId, selectedVins.join("|")],
		queryFn: async () => getGPSEmbeddedURL(locationId as string, accountId as string, selectedVins),
		enabled: Boolean(locationId) && Boolean(accountId),
	});

	if (isLoadingEmbeddedURL) {
		return (
			<Box width="100%" height="610px" py={4}>
				<Skeleton variant="rectangular" width="100%" height="610px" />
			</Box>
		);
	}

	return (
		<iframe
			src={url ?? ""}
			title="Embedded Asset Location Management"
			className={"w-[1490px] scale-[0.9] -ml-[75px] -mt-[35px] min-h-[720px] max-h-inherit pt-5 pb-5"}
		/>
	);
}
